import { connect } from 'react-redux';
import { getUserEmail, getUserName, getCustomText, isClientReady } from 'app/modules';
import configSelectors from 'selectors/configuration';
import uiEnums from 'enums/ui';

import InteractiveOnboarding from 'presentation/selfService/InteractiveOnboarding';

export const mapStateToProps = (state, props) => {
  const shouldReverseConditionsForOnboardingMessages =
    configSelectors.getOnboarding(state.configuration).initialCompositionStage === uiEnums.COMPOSITION_STAGES.NAME;
  let email = getUserEmail(state);
  let name = getUserName(state);

  // This creates and orders the user message contents for the messages.
  // Since we are reading these from the state and not from smooch messages, we have to handle this here, and outside the normal flow
  // Ternaries are solely used for the changes associated with this swap
  let userMessageContents = {
    firstMessage: shouldReverseConditionsForOnboardingMessages ? name : email,
    secondMessage: shouldReverseConditionsForOnboardingMessages ? email : name,
  };

  return {
    customText: getCustomText(state),
    email,
    isClientReady: isClientReady(state),
    isReadyForConfirmation: !!(
      isClientReady(state) &&
      (getUserName(state) || (shouldReverseConditionsForOnboardingMessages && email))
    ),
    name: getUserName(state),
    updateScrollPosition: props.updateScrollPosition,
    userMessageContents,
  };
};

export default connect(mapStateToProps)(InteractiveOnboarding);
